import React from 'react';
import classNames from 'classnames';
import { Box, makeStyles } from '@material-ui/core';
import { formatLiveAgentTime } from '../../../utils/notification';

import { Text } from '../../common';
import NotificationFileList from './NotificationFileList';

const useStyles = makeStyles(theme => ({
  marginTop: {
    marginTop: theme.spacing(2)
  },
  notificationWrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: `0 ${theme.spacing(1.5)}px`
  },
  notificationWrapperVisitor: {
    justifyContent: 'flex-end'
  },
  notification: {
    maxWidth: 262,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.background.default,
    justifyContent: 'space-between',
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: theme.shape.borderRadius * 4,
    padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    boxSizing: 'border-box',
    transition: theme.transitions.custom.fast,

    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 20,
      left: -1,
      transform: 'translateX(-50%) rotate(-45deg)',
      width: 16,
      height: 16,
      background: theme.palette.background.default,
      borderTop: `1px solid ${theme.palette.secondary.light}`,
      borderLeft: `1px solid ${theme.palette.secondary.light}`
    },

    '&:hover': {
      borderColor: theme.palette.secondary.main,
      boxShadow: theme.customShadows.active,

      '&::before': {
        borderTopColor: theme.palette.secondary.main,
        borderLeftColor: theme.palette.secondary.main
      }
    }
  },
  notificationVisitor: {
    borderColor: theme.palette.primary.light,

    '&::before': {
      left: 'unset',
      right: -1,
      transform: 'translateX(50%) rotate(135deg)',
      borderTopColor: theme.palette.primary.light,
      borderLeftColor: theme.palette.primary.light
    },

    '&:hover': {
      borderColor: theme.palette.primary.main,

      '&::before': {
        borderTopColor: theme.palette.primary.main,
        borderLeftColor: theme.palette.primary.main
      }
    }
  },
  body: {
    whiteSpace: 'normal'
  },
  time: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row'
  },
  manager: {
    marginLeft: theme.spacing(1)
  }
}));

const LiveAgentNotificationMessages = ({
  messages,
  startdatetimeutc,
  casemanager
}) => {
  const classes = useStyles();

  return (
    <>
      {messages.map(({ timeat, user, body, direction, files }) => (
        <Box
          key={direction + timeat.hour + timeat.minute + timeat.second}
          className={classNames(
            classes.notificationWrapper,
            classes.marginTop,
            direction === 'FROM_CUSTOMER' && classes.notificationWrapperVisitor
          )}
        >
          <Box
            className={classNames(
              classes.notification,
              direction === 'FROM_CUSTOMER' && classes.notificationVisitor
            )}
          >
            <Text
              className={classes.body}
              component="p"
              variant="body2"
              color="textPrimary"
            >
              {body}
            </Text>
            {files && files.length > 0 && (
              <NotificationFileList compact files={files} />
            )}
            <Box className={classes.time}>
              <Text variant="subtitle2" color="textHint">
                {formatLiveAgentTime(startdatetimeutc, timeat)}
              </Text>
              <Text
                className={classes.manager}
                variant="subtitle2"
                color="textHint"
              >
                {direction === 'FROM_CUSTOMER' ? user : casemanager}
              </Text>
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default LiveAgentNotificationMessages;
